import React from 'react'
import type { CenterProps } from '@vtex/admin-ui'
import { Center, color, csx, cx } from '@vtex/admin-ui'

type SalesAssociateCardAvatarProps = CenterProps

export const SalesAssociateCardAvatar = ({
  className = '',
  ...props
}: SalesAssociateCardAvatarProps) => (
  <Center
    className={cx(
      csx({
        backgroundColor: color('$blue20'),
        borderRadius: '50%',
        fontWeight: '500',
        width: '2.5rem',
        height: '2.5rem',
      }),
      className
    )}
  >
    {props.children}
  </Center>
)
